import { useMemo } from 'react';
import { useBatchedAvailability } from '@/hooks/useBatchedAvailability';

type AvailabilityIndex = Record<
  string,
  { unavailableDates?: Date[]; isLoading?: boolean; error?: unknown }
>;

export const useAvailabilityIndex = (propertyIds: string[]) => {
  const raw = useBatchedAvailability(propertyIds);

  const snapshot = useMemo(() => {
    return propertyIds
      .map((id) => {
        const av = raw[id];
        const l = av?.isLoading ? 1 : 0;
        const len = Array.isArray(av?.unavailableDates)
          ? av!.unavailableDates!.length
          : -1;
        const e = av?.error ? 1 : 0;
        return `${id}:${l}:${len}:${e}`;
      })
      .join('|');
  }, [propertyIds, raw]);

  const anyLoading = useMemo(
    () => propertyIds.some((id) => raw[id]?.isLoading),
    [propertyIds, snapshot],
  );

  const hasErrors = useMemo(
    () => propertyIds.some((id) => !!raw[id]?.error),
    [propertyIds, snapshot],
  );

  return {
    availability: raw as AvailabilityIndex,
    anyLoading,
    hasErrors,
    snapshot,
  };
};
